import React from 'react'

const index = () => {
  return (
    <div>Document</div>
  )
}

export default index